import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithStationeryProductDetailsHealthProvider, useStationeryProductDetailsPageHealth] = createComponentHealth('StationeryProductDetailsPage');
